import React from "react";
import { Box, Typography, Button, Container } from "@mui/material";
import GetAppIcon from "@mui/icons-material/GetApp";
import { useTranslation } from "../../hooks/useTranslation";
import { config } from "../../config/config";

export const Extension: React.FC = () => {
  const { translate } = useTranslation("pages.extension");

  const downloadUrl =
    config.ENV === "prod"
      ? "https://ext.syncrosale.com/syncrosale-extension.zip"
      : `https://ext.${config.ENV}.syncrosale.com/syncrosale-extension-${config.ENV}.zip`;

  return (
    <Box sx={{ py: 6 }}>
      {/* Hero Section */}
      <Container sx={{ textAlign: "center", mb: 8 }}>
        <Typography variant="h2" fontWeight="bold" gutterBottom>
          {translate("boostYourWorkflow")}
          <Typography variant="h3">{translate("with")}</Typography>
          {translate("syncrosaleExtension")}
        </Typography>
        <Typography variant="h5" color="textSecondary" gutterBottom>
          {translate("saveTimeAutomateTasks")}
        </Typography>
        <Button
          variant="contained"
          size="large"
          endIcon={<GetAppIcon />}
          href={downloadUrl}
          sx={{
            background: (theme) => theme.palette.primary.main,
            padding: "12px 36px",
            fontSize: "1.2rem",
            borderRadius: "50px",
            mt: 5,
            color: "#fff",
            "&:hover": {
              background: (theme) => theme.palette.primary.dark,
            },
          }}
        >
          {translate("download")}
        </Button>
      </Container>
    </Box>
  );
};
